import React, { useEffect, useState } from 'react';
import moment, { Moment } from 'moment';
import locale from 'antd/es/date-picker/locale/hr_HR';
import 'moment/locale/hr';
import { NavigationAndActionCalendar } from 'modules/ui/icons';
import {
  InputWithLabel,
  InputWithLabelProps,
} from '../inputWithLabel/InputWithLabel';
import { StyledAntDatePicker, StyledAntDatePickerWrapper } from './styled';

interface DatePickerProps extends Omit<InputWithLabelProps, 'onChange'> {
  dateFormat?: string;
  showToday?: boolean;
  onChange?: (value: string) => void;
}

export const DatePicker: React.FC<DatePickerProps> = ({
  dateFormat = 'DD.MM.YYYY.',
  showToday = true,
  onChange,
  ...props
}) => {
  useEffect(() => {
    moment().locale('hr');
  }, []);

  const [value, setValue] = useState<Moment>();

  useEffect(() => {
    props.defaultValue
      ? setValue(moment(props.defaultValue as string, dateFormat))
      : setValue(undefined);
  }, [dateFormat, props.defaultValue]);

  const onCalendarChange = (dateValue: Moment | null, dateString: string) => {
    dateString
      ? setValue(moment(dateString, dateFormat) || undefined)
      : setValue(undefined);

    onChange && onChange(dateString || '');
  };

  const onBlurChange = (inputValue?: string) => {
    onChange && onChange(parseDate(inputValue));
  };

  const handleDateClear = () => {
    onCalendarChange(null, '');
  };

  const parseDate = (date?: string) => {
    if (date) {
      if (moment(date, dateFormat).isValid()) {
        return date;
      }
    }

    return '';
  };

  return (
    <StyledAntDatePickerWrapper>
      <StyledAntDatePicker
        locale={locale}
        suffixIcon={<NavigationAndActionCalendar width="21px" />}
        allowClear={false}
        showToday={showToday}
        format={dateFormat}
        $disabled={props?.disabled || false}
        inputRender={(
          inputProps: React.InputHTMLAttributes<HTMLInputElement>,
        ) => (
          <InputWithLabel
            {...inputProps}
            readOnly={false}
            type="date"
            {...props}
            parser={parseDate}
            onBlur={(e) => onBlurChange(e.target.value)}
            onClear={handleDateClear}
            onPaste={(e) => e.preventDefault()}
          />
        )}
        getPopupContainer={(triggerNode) => triggerNode as HTMLElement}
        onChange={onCalendarChange}
        value={value}
      />
    </StyledAntDatePickerWrapper>
  );
};
